function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
const BASE_URL = '/revenue-entries/configuration';
class RevenueConfigApiClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getRevenueConfig", ()=>{
            return this.get(BASE_URL);
        }), _define_property(this, "updateRevenueConfig", (revenueConfig)=>{
            return this.put(BASE_URL, revenueConfig);
        });
    }
}
export const RevenueConfigApi = new RevenueConfigApiClient();
